export default __webpack_public_path__ + "static/media/fab-logo.59fa61b5.png";